export const FEED_TYPES = [
  "following",
  "for_you",
  "groups",
  "custom",
  "watch",
] as const;

export type FeedType = (typeof FEED_TYPES)[number];
